(function () {
  const ROOT = document.querySelector('[data-header-root]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuOpenButton = document.querySelector('[data-menu-toggle]');
  const menuCloseButton = document.querySelector('[data-menu-close]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartCloseButtons = Array.from(document.querySelectorAll('[data-cart-close]'));
  const cartCountNodes = Array.from(document.querySelectorAll('[data-cart-count]'));
  const cartCountLabel = document.querySelector('[data-cart-count-label]');
  const cartItemsRoot = document.querySelector('[data-cart-drawer-items]');
  const cartSubtotal = document.querySelector('[data-cart-drawer-subtotal-summary]');
  const cartShipping = document.querySelector('[data-cart-drawer-shipping]');
  const cartDiscount = document.querySelector('[data-cart-drawer-discount]');
  const cartDiscountRow = document.querySelector('[data-cart-drawer-discount-row]');
  const isCartTemplate = document.body.classList.contains('template-cart');

  const state = {
    cartPromise: null,
    updatePromise: null,
  };

  const setCartDrawerBusy = (busy) => {
    cartDrawer?.classList.toggle('is-updating', busy);

    const controls = document.querySelectorAll(
      '[data-cart-qty-change], [data-cart-remove-line], [data-cart-cross-sell-add]',
    );

    for (const control of controls) {
      if (!(control instanceof HTMLElement)) {
        continue;
      }

      control.classList.toggle('is-busy', busy);

      if ('disabled' in control) {
        control.disabled = busy;
      }
    }
  };

  const formatMoney = (amount, currency) =>
    new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: currency || 'COP',
      maximumFractionDigits: 0,
    }).format(Math.max(0, amount)).replace(/\s/g, '');

  const setBodyLock = (locked) => {
    document.body.classList.toggle('overflow-hidden', locked);
  };

  const closeMenu = () => {
    if (!mobileMenu || !menuOpenButton) {
      return;
    }

    mobileMenu.hidden = true;
    menuOpenButton.setAttribute('aria-expanded', 'false');
    setBodyLock(false);
  };

  const openMenu = () => {
    if (!mobileMenu || !menuOpenButton) {
      return;
    }

    mobileMenu.hidden = false;
    menuOpenButton.setAttribute('aria-expanded', 'true');
    setBodyLock(true);
  };

  const closeCartDrawer = () => {
    if (!cartDrawer || !cartToggle) {
      return;
    }

    cartDrawer.hidden = true;
    cartToggle.setAttribute('aria-expanded', 'false');
    setBodyLock(false);
  };

  const openCartDrawer = async () => {
    if (!cartDrawer || !cartToggle) {
      return;
    }

    closeMenu();
    cartDrawer.hidden = false;
    cartToggle.setAttribute('aria-expanded', 'true');
    setBodyLock(true);
    await refreshCart();
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Cart request failed with ${response.status}`);
    }

    return response.json();
  };

  const refreshCart = async () => {
    if (state.cartPromise) {
      return state.cartPromise;
    }

    state.cartPromise = fetchCart()
      .then((cart) => {
        renderCart(cart);
        return cart;
      })
      .finally(() => {
        state.cartPromise = null;
      });

    return state.cartPromise;
  };

  const lineTimers = new Map();
  const scheduleLineUpdate = (line, quantity, delay = 450) => {
    if (!line) return;
    window.clearTimeout(lineTimers.get(line));
    lineTimers.set(
      line,
      window.setTimeout(() => {
        lineTimers.delete(line);
        void updateCartLine(line, quantity);
      }, delay),
    );
  };

  const updateCartLine = async (line, quantity) => {
    if (!line) {
      return;
    }

    if (state.updatePromise) {
      await state.updatePromise;
    }

    setCartDrawerBusy(true);
    state.updatePromise = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        line,
        quantity,
      }),
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Cart change failed with ${response.status}`);
        }

        return response.json();
      })
      .then((cart) => {
        renderCart(cart);
        if (isCartTemplate) {
          window.location.reload();
        }
      })
      .finally(() => {
        setCartDrawerBusy(false);
        state.updatePromise = null;
      });

    return state.updatePromise;
  };

  // Los agregados desde recomendaciones pasan por el mismo control de edad que los formularios.
  const withAgeCheck = (action) => {
    if (window.LollipopAgeGate?.require) window.LollipopAgeGate.require(action);
    else action();
  };

  const markAddFailed = (button) => {
    if (!(button instanceof HTMLElement)) return;
    button.textContent = 'No disponible';
    button.setAttribute('disabled', '');
  };

  const addVariantToCart = async (variantId, quantity = 1) => {
    if (!variantId) {
      return;
    }

    if (state.updatePromise) {
      await state.updatePromise;
    }

    setCartDrawerBusy(true);
    state.updatePromise = fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity,
      }),
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Cart add failed with ${response.status}`);
        }

        return refreshCart();
      })
      .then((cart) => {
        if (isCartTemplate) {
          window.location.reload();
        }

        return cart;
      })
      .finally(() => {
        setCartDrawerBusy(false);
        state.updatePromise = null;
      });

    return state.updatePromise;
  };

  const updateCartCount = (itemCount) => {
    for (const node of cartCountNodes) {
      node.textContent = String(itemCount);
      node.classList.toggle('hidden', itemCount <= 0);
    }

    if (cartCountLabel) {
      cartCountLabel.textContent = `(${itemCount})`;
    }
  };

  // Pedido mínimo: una sola implementación en assets/order-threshold.js.
  const renderMinimum = (cart) => {
    window.LollipopThreshold?.render(cart);
  };

  // Complementos: recomendaciones nativas de Shopify (complementary y, si no hay, related).
  // Sin respaldo alfabético: si Shopify no devuelve nada, el bloque no aparece.
  const recommendationCache = new Map();
  const fetchRecommendations = async (productId, limit = 6) => {
    const key = `${productId}:${limit}`;
    if (recommendationCache.has(key)) return recommendationCache.get(key);
    const root = window.Shopify?.routes?.root || '/';
    const load = async (intent) => {
      const response = await fetch(`${root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`);
      if (!response.ok) return [];
      const data = await response.json();
      return Array.isArray(data.products) ? data.products : [];
    };
    const request = (async () => {
      try {
        const complementary = await load('complementary');
        return complementary.length ? complementary : await load('related');
      } catch {
        return [];
      }
    })();
    recommendationCache.set(key, request);
    return request;
  };

  const pickRecommendations = (products, excludeIds, count) =>
    products
      .filter((product) => product.available && !excludeIds.has(product.id))
      .map((product) => {
        const variant = (product.variants || []).find((v) => v.available);
        return variant ? { product, variantId: variant.id } : null;
      })
      .filter(Boolean)
      .slice(0, count);

  const recommendationImage = (product, width) => {
    const src = product.featured_image || product.images?.[0];
    if (!src) return '';
    const url = `${src}${src.includes('?') ? '&' : '?'}width=${width}`;
    return `<img src="${escapeAttr(url)}" alt="${escapeAttr(product.title)}" loading="lazy" width="${width}" height="${width}">`;
  };

  const escapeAttr = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

  const loadCartCrossSell = async (cart) => {
    const slot = cartItemsRoot?.querySelector('[data-cart-cross-sell]');
    const first = cart.items?.[0];
    if (!slot || !first) return;
    // Cascada H en el carrito: sólo bajo el mínimo. Primero los que completan el pedido al menor precio
    // (precio ≥ lo que falta, de menor a mayor); después los más cercanos por debajo. Así el bloque no
    // desaparece cuando falta poco. Fuente: recomendación nativa de los productos del carrito.
    const threshold = window.LollipopThreshold?.readConfig?.().threshold || 0;
    const remaining = threshold - Number(cart.total_price || 0);
    if (!threshold || remaining <= 0) return;
    const inCart = new Set(cart.items.map((item) => item.product_id));
    const seeds = [...new Set(cart.items.map((item) => item.product_id))].slice(0, 3);
    const seen = new Set();
    const pool = (await Promise.all(seeds.map((id) => fetchRecommendations(id, 10)))).flat()
      .filter((product) => (seen.has(product.id) ? false : seen.add(product.id)));
    const completes = pool.filter((product) => product.price >= remaining).sort((a, b) => a.price - b.price);
    const below = pool.filter((product) => product.price < remaining).sort((a, b) => b.price - a.price);
    const picks = pickRecommendations([...completes, ...below], inCart, 3);
    if (!picks.length || !slot.isConnected) return;
    slot.innerHTML = `
      <div class="cart-drawer__cross-sell-head">
        <p class="cart-drawer__cross-sell-title">Completa tu pedido</p>
        <span>Te faltan ${formatMoney(remaining / 100, 'COP')}</span>
      </div>
      <div class="cart-drawer__cross-sell-list">
        ${picks.map(({ product, variantId }) => `
          <div class="cart-drawer__cross-sell-card">
            <a href="${escapeAttr(product.url)}" class="cart-drawer__cross-sell-media" tabindex="-1" aria-hidden="true">${recommendationImage(product, 120)}</a>
            <div class="cart-drawer__cross-sell-info">
              ${product.type ? `<span class="cart-drawer__cross-sell-reason">${escapeAttr(product.type)}</span>` : ''}
              <a href="${escapeAttr(product.url)}" class="cart-drawer__cross-sell-name">${escapeAttr(product.title)}</a>
              <span class="cart-drawer__cross-sell-price">${formatMoney(product.price / 100, 'COP')}</span>
            </div>
            <button type="button" class="cart-drawer__cross-sell-add" data-cart-cross-sell-add="${variantId}">Agregar</button>
          </div>`).join('')}
      </div>`;
    slot.hidden = false;
  };

  const initPdpCrossSell = async () => {
    const slot = document.querySelector('[data-pdp-cross-sell]');
    const productId = Number(slot?.getAttribute('data-product-id') || 0);
    if (!slot || !productId) return;
    const grid = slot.querySelector('[data-pdp-cross-sell-grid]');
    const picks = pickRecommendations(await fetchRecommendations(productId), new Set([productId]), 2);
    if (!grid || !picks.length) return;
    grid.innerHTML = picks
      .map(({ product, variantId }) => `
        <div class="product-main__cross-sell-card">
          <a href="${escapeAttr(product.url)}" class="product-main__cross-sell-media">${recommendationImage(product, 200).replace('<img ', '<img class="product-main__cross-sell-image" ')}</a>
          <div class="product-main__cross-sell-info">
            <a href="${escapeAttr(product.url)}" class="product-main__cross-sell-name">${escapeAttr(product.title)}</a>
            <span class="product-main__cross-sell-price">${formatMoney(product.price / 100, 'COP')}</span>
            <button type="button" class="product-main__cross-sell-label" data-cart-cross-sell-add="${variantId}">Agregar al carrito</button>
          </div>
        </div>`)
      .join('');
    slot.hidden = false;
    slot.closest("section")?.removeAttribute("hidden");
  };

  const renderCartItems = (cart, currency) => {
    if (!cartItemsRoot) {
      return;
    }

    if (!Array.isArray(cart.items) || cart.items.length === 0) {
      cartItemsRoot.innerHTML = `
        <div class="cart-drawer__empty">
          <p class="cart-drawer__empty-title">Tu carrito está vacío</p>
          <a href="/collections" class="button button--primary cart-drawer__empty-cta">Explorar categorías</a>
        </div>`;
      return;
    }

    cartItemsRoot.innerHTML = cart.items
      .map((item, index) => {
        const line = index + 1;
        const image = item.image
          ? `<img src="${escapeAttr(item.image)}${item.image.includes('?') ? '&' : '?'}width=160" alt="" class="cart-drawer__item-image" loading="lazy" width="80" height="80">`
          : '';
        const detail = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : item.product_type || '';
        return `
          <article class="cart-drawer__item" data-cart-line="${line}">
            <a href="${escapeAttr(item.url)}" class="cart-drawer__item-media" tabindex="-1" aria-hidden="true">${image}</a>
            <div class="cart-drawer__item-content">
              <div class="cart-drawer__item-top">
                <a href="${escapeAttr(item.url)}" class="cart-drawer__item-title">${escapeAttr(item.product_title)}</a>
                <span class="cart-drawer__item-price">${formatMoney(item.final_line_price / 100, currency)}</span>
              </div>
              ${detail ? `<p class="cart-drawer__item-variant">${escapeAttr(detail)}</p>` : ''}
              <div class="cart-drawer__item-bottom">
                <div class="cart-drawer__qty">
                  <button type="button" class="cart-drawer__qty-btn" data-cart-qty-change="-1" data-cart-line="${line}" aria-label="Quitar una unidad">−</button>
                  <input class="cart-drawer__qty-value" type="number" inputmode="numeric" min="0" value="${item.quantity}" aria-label="Cantidad" data-cart-qty-input data-cart-line="${line}">
                  <button type="button" class="cart-drawer__qty-btn" data-cart-qty-change="1" data-cart-line="${line}" aria-label="Agregar una unidad">+</button>
                </div>
                <button type="button" class="cart-drawer__remove" data-cart-remove-line="${line}">Eliminar</button>
              </div>
            </div>
          </article>`;
      })
      .join('') + '<div class="cart-drawer__cross-sell" data-cart-cross-sell hidden></div>';
    void loadCartCrossSell(cart);
  };

  const renderCartSummary = (cart, currency) => {
    if (!cartSubtotal || !cartShipping) {
      return;
    }

    const subtotal = Number(cart.items_subtotal_price || 0);
    const total = Number(cart.total_price || 0);
    const discount = Math.max(0, subtotal - total);
    const cfg = window.LollipopThreshold?.readConfig() || { threshold: 0 };
    const shippingReached = cfg.threshold > 0 && total > 0 && total >= cfg.threshold;
    cartSubtotal.textContent = formatMoney(subtotal / 100, currency);
    if (cartDiscount && cartDiscountRow) {
      cartDiscount.textContent = `−${formatMoney(discount / 100, currency)}`;
      cartDiscountRow.hidden = discount <= 0;
    }
    cartShipping.textContent = shippingReached
      ? cartShipping.getAttribute('data-shipping-free') || 'Gratis'
      : cartShipping.getAttribute('data-shipping-pending') || '';
  };

  const renderCart = (cart) => {
    const currency = cart.currency || 'COP';
    updateCartCount(Number(cart.item_count || 0));
    renderMinimum(cart);
    renderCartItems(cart, currency);
    renderCartSummary(cart, currency);
  };

  const bindMobileMenu = () => {
    if (!ROOT || !mobileMenu || !menuOpenButton || !menuCloseButton) {
      return;
    }

    menuOpenButton.addEventListener('click', () => {
      if (mobileMenu.hidden) {
        openMenu();
        return;
      }

      closeMenu();
    });

    menuCloseButton.addEventListener('click', closeMenu);

    mobileMenu.addEventListener('click', (event) => {
      if (event.target === mobileMenu) {
        closeMenu();
      }
    });
  };

  const bindCartDrawer = () => {
    if (!cartDrawer || !cartToggle) {
      return;
    }

    cartToggle.addEventListener('click', (event) => {
      event.preventDefault();
      void openCartDrawer();
    });

    for (const button of cartCloseButtons) {
      button.addEventListener('click', closeCartDrawer);
    }

    cartDrawer.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;

      if (!target) {
        return;
      }

      const crossSellAdd = target.closest('[data-cart-cross-sell-add]');
      if (crossSellAdd instanceof HTMLElement) {
        event.preventDefault();
        const variantId = crossSellAdd.getAttribute('data-cart-cross-sell-add');
        withAgeCheck(() => { void addVariantToCart(variantId).catch(() => markAddFailed(crossSellAdd)); });
        return;
      }

      const removeLine = target.getAttribute('data-cart-remove-line');

      if (removeLine) {
        void updateCartLine(Number(removeLine), 0);
        return;
      }

      const qtyButton = target.closest('[data-cart-qty-change]');

      if (qtyButton instanceof HTMLElement) {
        // La cantidad cambia al instante en pantalla; el carrito se actualiza una sola vez cuando se deja de pulsar.
        const line = Number(qtyButton.getAttribute('data-cart-line') || 0);
        const delta = Number(qtyButton.getAttribute('data-cart-qty-change') || 0);
        const input = qtyButton.closest('.cart-drawer__qty')?.querySelector('[data-cart-qty-input]');
        const current = Number(input?.value || 1);
        const next = Math.max(0, current + delta);
        if (input) input.value = String(next);
        scheduleLineUpdate(line, next);
      }
    });

    cartDrawer.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-cart-qty-input')) return;
      const next = Math.max(0, Math.floor(Number(input.value)));
      if (!Number.isFinite(next)) return;
      input.value = String(next);
      scheduleLineUpdate(Number(input.getAttribute('data-cart-line') || 0), next, 0);
    });

    cartDrawer.addEventListener('keydown', (event) => {
      const input = event.target;
      if (event.key === 'Enter' && input instanceof HTMLInputElement && input.hasAttribute('data-cart-qty-input')) {
        event.preventDefault();
        input.blur();
      }
    });
  };

  const bindStandaloneCartAdds = () => {
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;

      if (!target) {
        return;
      }

      const crossSellAdd = target.closest('[data-cart-cross-sell-add]');

      if (!(crossSellAdd instanceof HTMLElement)) {
        return;
      }

      if (cartDrawer?.contains(crossSellAdd)) {
        return;
      }

      event.preventDefault();
      const variantId = crossSellAdd.getAttribute('data-cart-cross-sell-add');
      withAgeCheck(() => {
        void addVariantToCart(variantId)
          .then(() => { if (!isCartTemplate) void openCartDrawer(); })
          .catch(() => markAddFailed(crossSellAdd));
      });
    });
  };

  // Mega menú A+: el HTML trae todos los enlaces; aquí sólo se abre (clic, Enter, hover con retardo) y se cierra (Escape, clic fuera).
  const bindMegaMenu = () => {
    const items = Array.from(document.querySelectorAll('[data-nav-item].has-mega'));
    if (!items.length) return;
    const hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    const setOpen = (item, open) => {
      item.classList.toggle('is-open', open);
      item.querySelector('[data-nav-trigger]')?.setAttribute('aria-expanded', String(open));
    };
    const closeAll = (except) => items.forEach((item) => item !== except && setOpen(item, false));
    items.forEach((item) => {
      const trigger = item.querySelector('[data-nav-trigger]');
      let timer = null;
      trigger?.addEventListener('click', () => {
        const open = !item.classList.contains('is-open');
        closeAll(item);
        setOpen(item, open);
      });
      item.addEventListener('mouseenter', () => {
        if (!hoverQuery.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
          closeAll(item);
          setOpen(item, true);
        }, 150);
      });
      item.addEventListener('mouseleave', () => {
        if (!hoverQuery.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => setOpen(item, false), 200);
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = items.find((item) => item.classList.contains('is-open'));
      if (!open) return;
      setOpen(open, false);
      open.querySelector('[data-nav-trigger]')?.focus();
    });
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('[data-nav-item]')) closeAll(null);
    });
  };

  const bindSearchToggle = () => {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchContainer = document.querySelector('[data-search-container]');
    const searchClose = document.querySelector('[data-search-close]');
    const searchInput = document.querySelector('.site-header__search-input');
    const suggestionsBox = document.querySelector('[data-search-suggestions]');

    if (!searchToggle || !searchContainer) {
      return;
    }

    const openSearch = () => {
      searchContainer.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) {
        searchInput.focus();
      }
    };

    const closeSearch = () => {
      searchContainer.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
      if (suggestionsBox) {
        suggestionsBox.hidden = true;
      }
    };

    searchToggle.addEventListener('click', () => {
      if (searchContainer.hidden) {
        openSearch();
      } else {
        closeSearch();
      }
    });

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !searchContainer.hidden) {
        closeSearch();
      }
    });

    if (!searchInput || !suggestionsBox) {
      return;
    }

    let debounceTimer = null;
    let searchAbortController = null;
    let latestSearchQuery = '';

    const escapeHtml = (value) =>
      String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char]);

    const getSuggestionImage = (image) => {
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.url || image.src || image.preview_image?.src || '';
    };

    const getSuggestionPrice = (price) => {
      if (typeof price === 'number') return formatMoney(price, 'COP');
      if (typeof price !== 'string' || !price.trim()) return '';

      const numeric = Number(price);
      if (Number.isFinite(numeric)) return formatMoney(numeric, 'COP');

      return price;
    };

    const quickBox = searchContainer.querySelector('[data-search-quick]');
    const showQuick = (visible) => {
      if (quickBox) quickBox.hidden = !visible;
    };

    const searchUrl = (q) =>
      `/search?q=${encodeURIComponent(q)}&type=product&options[unavailable_products]=last&options[prefix]=last&sort_by=relevance`;

    // Panel de búsqueda A+: sugerencias de consulta, colecciones, guías y productos (API nativa /search/suggest.json).
    const renderSuggestions = (results, query) => {
      const queries = (results.queries || []).slice(0, 3);
      const collections = (results.collections || []).slice(0, 2);
      const guides = (results.articles || []).slice(0, 2);
      const products = (results.products || []).slice(0, 4);
      if (!queries.length && !collections.length && !guides.length && !products.length) {
        suggestionsBox.hidden = true;
        return;
      }
      const group = (label, items) => (items ? `<p class="search-suggest__label">${label}</p>${items}` : '');
      const left =
        group('Sugerencias', queries.map((q) => `<a href="${escapeHtml(q.url || searchUrl(q.text))}" class="search-suggest__row">${q.styled_text || escapeHtml(q.text)}</a>`).join('')) +
        group('Colecciones', collections.map((c) => `<a href="${escapeHtml(c.url)}" class="search-suggest__row">${escapeHtml(c.title)}</a>`).join('')) +
        group('Guías', guides.map((g) => `<a href="${escapeHtml(g.url)}" class="search-suggest__row">${escapeHtml(g.title)}</a>`).join(''));
      const right = group(
        'Productos',
        products
          .map((p) => {
            const imageUrl = getSuggestionImage(p.image);
            const price = getSuggestionPrice(p.price);
            return `
            <a href="${escapeHtml(p.url)}" class="search-suggestion__item">
              <span class="search-suggestion__thumb">${imageUrl ? `<img src="${escapeHtml(imageUrl)}${imageUrl.includes('?') ? '&' : '?'}width=120" alt="" loading="lazy" width="56" height="56">` : ''}</span>
              <span class="search-suggestion__info">
                <span class="search-suggestion__name">${escapeHtml(p.title)}</span>
                <span class="search-suggestion__meta">${price ? `<strong>${escapeHtml(price)}</strong>` : ''}${p.available ? ' <span class="search-suggestion__stock">Disponible</span>' : ' <span class="search-suggestion__soldout">Agotado</span>'}</span>
              </span>
            </a>`;
          })
          .join(''),
      );
      suggestionsBox.innerHTML = `
        <div class="search-suggest__cols">
          ${left ? `<div class="search-suggest__col">${left}</div>` : ''}
          ${right ? `<div class="search-suggest__col">${right}</div>` : ''}
        </div>
        <a href="${escapeHtml(searchUrl(query))}" class="search-suggestion__all">Ver todos los resultados para «${escapeHtml(query)}»</a>`;
      showQuick(false);
      suggestionsBox.hidden = false;
    };

    const fetchSuggestions = async (query) => {
      if (!query || query.length < 2) {
        suggestionsBox.hidden = true;
        showQuick(document.activeElement === searchInput);
        return;
      }

      try {
        latestSearchQuery = query;
        if (searchAbortController) {
          searchAbortController.abort();
        }
        searchAbortController = new AbortController();
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article,query&resources[limit]=4&resources[options][unavailable_products]=last`,
          { signal: searchAbortController.signal },
        );
        if (!response.ok) throw new Error('suggest failed');
        const data = await response.json();
        if (query !== latestSearchQuery) return;
        renderSuggestions(data.resources?.results || {}, query);
      } catch (error) {
        if (error?.name === 'AbortError') return;
        console.error('[Lollipop] search suggest error', error);
        suggestionsBox.hidden = true;
      }
    };

    searchInput.addEventListener('focus', () => {
      if (!searchInput.value.trim()) showQuick(true);
    });

    searchInput.addEventListener('input', (event) => {
      const query = event.target.value.trim();
      latestSearchQuery = query;
      searchAbortController?.abort();
      suggestionsBox.hidden = true;
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(() => {
        void fetchSuggestions(query);
      }, 220);
    });

    searchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        suggestionsBox.hidden = true;
        showQuick(false);
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (
        target &&
        !target.closest('[data-search-suggestions]') &&
        !target.closest('.site-header__search-form')
      ) {
        suggestionsBox.hidden = true;
        showQuick(false);
      }
    });
  };

  const bindProductForm = () => {
    document.addEventListener('submit', (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.classList.contains('product-form')) {
        return;
      }

      event.preventDefault();
      const idInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      const qtyInput = form.querySelector('input[name="quantity"]');
      const button = form.querySelector('button[type="submit"]');
      const id = idInput?.value;
      const quantity = Math.max(1, Number(qtyInput?.value || 1));

      if (!id) {
        form.submit();
        return;
      }

      const originalLabel = button ? button.textContent : 'Agregar al carrito';

      if (button) {
        button.textContent = 'Agregando...';
        button.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id, quantity }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Add failed with ${response.status}`);
          }
          return response.json();
        })
        .then(() => {
          if (button) {
            button.textContent = 'Agregado ✓';
            window.setTimeout(() => {
              button.textContent = originalLabel;
              button.disabled = false;
            }, 1200);
          }
          if (isCartTemplate) {
            window.location.reload();
          } else {
            void openCartDrawer();
          }
        })
        .catch((error) => {
          console.error('[Lollipop] product form add failed', error);
          if (button) {
            button.textContent = originalLabel;
            button.disabled = false;
          }
          form.submit();
        });
    });
  };

  const bindAgeVerification = () => {
    const gate = document.getElementById('age-gate');
    if (!(gate instanceof HTMLElement)) return;

    const birthdateInput = gate.querySelector('[data-age-gate-birthdate]');
    const confirmButton = gate.querySelector('[data-age-gate-confirm]');
    const closeButtons = gate.querySelectorAll('[data-age-gate-close]');
    const errorNode = gate.querySelector('[data-age-gate-error]');
    let pendingForm = null;
    let pendingSubmitter = null;
    let pendingCallback = null;
    let returnFocus = null;
    let inertNodes = [];
    // Si el navegador bloquea localStorage, la confirmación vale al menos para esta página (evita un bucle del gate).
    let verifiedThisPage = false;

    const readVerified = () => {
      if (verifiedThisPage) return true;
      try {
        return window.localStorage.getItem('lollipop_age_verified') === '1';
      } catch (e) {
        return false;
      }
    };

    const writeVerified = () => {
      try {
        window.localStorage.setItem('lollipop_age_verified', '1');
        window.localStorage.setItem('lollipop_age_verified_at', new Date().toISOString());
      } catch (e) {}
    };

    const setError = (message) => {
      if (errorNode) errorNode.textContent = message || '';
    };

    const getAge = (dateValue) => {
      if (!dateValue) return null;
      const birthDate = new Date(`${dateValue}T00:00:00`);
      if (Number.isNaN(birthDate.getTime())) return null;
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age -= 1;
      }
      return age;
    };

    const closeGate = () => {
      gate.hidden = true;
      document.body.classList.remove('age-gate-open');
      inertNodes.forEach((node) => { node.inert = false; });
      inertNodes = [];
      pendingForm = null;
      pendingSubmitter = null;
      pendingCallback = null;
      setError('');
      if (returnFocus instanceof HTMLElement && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
      returnFocus = null;
    };

    const openGate = (form, submitter, callback) => {
      pendingForm = form || null;
      pendingSubmitter = submitter || null;
      pendingCallback = typeof callback === 'function' ? callback : null;
      returnFocus = document.activeElement;
      gate.hidden = false;
      document.body.classList.add('age-gate-open');
      // El resto de la página queda inerte mientras el diálogo está abierto (foco y lectores de pantalla).
      inertNodes = [...document.body.children].filter((node) => node !== gate && !node.contains(gate) && !node.inert);
      inertNodes.forEach((node) => { node.inert = true; });
      setError('');

      if (birthdateInput instanceof HTMLInputElement) {
        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() - 18);
        birthdateInput.max = maxDate.toISOString().slice(0, 10);
        window.setTimeout(() => birthdateInput.focus({ preventScroll: true }), 80);
      }
    };

    const continuePendingAction = () => {
      const form = pendingForm;
      const submitter = pendingSubmitter;
      const callback = pendingCallback;
      returnFocus = null;
      closeGate();
      document.dispatchEvent(new CustomEvent('lollipop:age-verified'));
      if (callback) window.setTimeout(callback, 0);

      if (form instanceof HTMLFormElement) {
        window.setTimeout(() => {
          if (typeof form.requestSubmit === 'function' && submitter instanceof HTMLElement) {
            form.requestSubmit(submitter);
          } else if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }, 0);
      }
    };

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || readVerified()) return;

        const needsAgeCheck =
          form.classList.contains('product-form') ||
          form.classList.contains('quick-add') ||
          Boolean(form.querySelector('[name="checkout"]'));

        if (!needsAgeCheck) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        openGate(form, event.submitter);
      },
      true,
    );

    if (confirmButton) {
      confirmButton.addEventListener('click', () => {
        const age = birthdateInput instanceof HTMLInputElement ? getAge(birthdateInput.value) : null;
        if (age === null) {
          setError('Selecciona una fecha de nacimiento válida.');
          return;
        }
        if (age < 18) {
          setError('No podemos procesar compras de menores de 18 años.');
          pendingForm = null;
          return;
        }

        verifiedThisPage = true;
        writeVerified();
        continuePendingAction();
      });
    }

    if (birthdateInput instanceof HTMLInputElement) {
      birthdateInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          confirmButton?.click();
        }
      });
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeGate);
    });

    document.addEventListener('keydown', (event) => {
      if (gate.hidden) return;
      if (event.key === 'Escape') {
        closeGate();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusables = [...gate.querySelectorAll('button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])')]
        .filter((node) => !node.disabled && node.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Para agregados fuera de un formulario (recomendaciones): ejecuta la acción si ya confirmó la edad o abre el gate.
    window.LollipopAgeGate = {
      isVerified: readVerified,
      require: (action) => {
        if (readVerified()) {
          action();
          return;
        }
        openGate(null, null, action);
      },
    };
  };

  const bindQuickAdd = () => {
    document.addEventListener('submit', (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.classList.contains('quick-add')) {
        return;
      }

      event.preventDefault();
      const idInput = form.querySelector('input[name="id"]');
      const button = form.querySelector('button[type="submit"]');
      const id = idInput?.value;

      if (!id) {
        form.submit();
        return;
      }

      const originalLabel = button ? button.textContent : 'Agregar';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Add failed with ${response.status}`);
          }
          return response.json();
        })
        .then(() => {
          if (button) {
            button.textContent = 'Agregado';
            window.setTimeout(() => {
              button.textContent = originalLabel;
            }, 1200);
          }
          if (isCartTemplate) {
            window.location.reload();
          } else {
            void openCartDrawer();
          }
        })
        .catch((error) => {
          console.error('[Lollipop] quick add failed', error);
          form.submit();
        });
    });
  };

  const bindLeadDiscountCapture = () => {
    const root = document.querySelector('[data-lead-discount-capture]');
    if (!(root instanceof HTMLElement)) return;

    const form = root.querySelector('[data-lead-discount-form]');
    const formView = root.querySelector('[data-lead-discount-form-view]');
    const successView = root.querySelector('[data-lead-discount-success-view]');
    const closeButtons = root.querySelectorAll('[data-lead-discount-close]');
    const copyButton = root.querySelector('[data-lead-discount-copy]');
    const copyStatus = root.querySelector('[data-lead-discount-copy-status]');
    const useDiscountLink = root.querySelector('[data-lead-discount-use]');
    const code = root.getAttribute('data-discount-code') || 'LOLLIW05';
    const delaySeconds = Math.max(0, Number(root.getAttribute('data-delay-seconds') || 10));
    const closedDays = Math.max(1, Number(root.getAttribute('data-closed-days') || 7));
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const storage = {
      ageVerified: 'lollipop_age_verified',
      claimed: 'lollipop_discount_claimed',
      code: 'lollipop_discount_code',
      claimedAt: 'lollipop_discount_claimed_at',
      dismissedAt: 'lollipop_discount_dismissed_at',
    };

    const readStorage = (key) => {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    };

    const writeStorage = (key, value) => {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    };

    const isAgeVerified = () => readStorage(storage.ageVerified) === '1';
    const isClaimed = () => readStorage(storage.claimed) === '1';

    const isDismissed = () => {
      const dismissedAt = Number(readStorage(storage.dismissedAt) || 0);
      if (!dismissedAt) return false;
      return Date.now() - dismissedAt < closedDays * 24 * 60 * 60 * 1000;
    };

    const canOpen = () => isAgeVerified() && !isClaimed() && !isDismissed() && root.hidden;

    const open = () => {
      if (!canOpen()) return;
      root.hidden = false;
      document.body.classList.add('lead-discount-open');
      const firstInput = root.querySelector('[data-lead-discount-name]');
      if (firstInput instanceof HTMLElement) {
        window.setTimeout(() => firstInput.focus({ preventScroll: true }), 80);
      }
    };

    const close = () => {
      root.hidden = true;
      document.body.classList.remove('lead-discount-open');
      writeStorage(storage.dismissedAt, String(Date.now()));
    };

    const setError = (name, message) => {
      const node = root.querySelector(`[data-error-for="${name}"]`);
      if (node) node.textContent = message;
    };

    const clearErrors = () => {
      root.querySelectorAll('[data-error-for]').forEach((node) => {
        node.textContent = '';
      });
    };

    const markClaimed = () => {
      writeStorage(storage.claimed, '1');
      writeStorage(storage.code, code);
      writeStorage(storage.claimedAt, new Date().toISOString());
    };

    const showSuccess = () => {
      markClaimed();
      if (formView instanceof HTMLElement) formView.hidden = true;
      if (successView instanceof HTMLElement) successView.hidden = false;
    };

    const validate = () => {
      if (!(form instanceof HTMLFormElement)) return false;
      clearErrors();

      const name = form.querySelector('[data-lead-discount-name]');
      const email = form.querySelector('[data-lead-discount-email]');
      const phone = form.querySelector('[data-lead-discount-phone]');
      const adult = form.querySelector('[data-lead-discount-adult]');
      const privacy = form.querySelector('[data-lead-discount-privacy]');
      const honeypot = form.querySelector('[data-lead-discount-honeypot]');
      let valid = true;

      if (honeypot instanceof HTMLInputElement && honeypot.value.trim() !== '') {
        honeypot.value = '';
      }

      if (!(name instanceof HTMLInputElement) || name.value.trim().length < 2) {
        setError('name', 'Ingresa tu nombre.');
        valid = false;
      }

      if (!(email instanceof HTMLInputElement) || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        setError('email', 'Ingresa un email válido.');
        valid = false;
      }

      if (!(phone instanceof HTMLInputElement) || phone.value.replace(/[^\d+]/g, '').length < 7) {
        setError('phone', 'Ingresa tu WhatsApp o celular.');
        valid = false;
      }

      if (!(adult instanceof HTMLInputElement) || !adult.checked) {
        setError('adult', 'Confirma que eres mayor de edad.');
        valid = false;
      }

      if (!(privacy instanceof HTMLInputElement) || !privacy.checked) {
        setError('privacy', 'Debes aceptar la política de privacidad.');
        valid = false;
      }

      return valid;
    };

    if (form instanceof HTMLFormElement) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!validate()) return;
        showSuccess();
      });

      const submitButton = form.querySelector('.lead-discount__submit');
      if (submitButton) {
        submitButton.addEventListener('click', (event) => {
          event.preventDefault();
          if (!validate()) return;
          showSuccess();
        });
      }
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        close();
      }
    });

    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        markClaimed();
        try {
          await navigator.clipboard.writeText(code);
        } catch (e) {
          const temporaryInput = document.createElement('input');
          temporaryInput.value = code;
          document.body.appendChild(temporaryInput);
          temporaryInput.select();
          document.execCommand('copy');
          temporaryInput.remove();
        }

        if (copyStatus instanceof HTMLElement) {
          copyStatus.hidden = false;
          window.setTimeout(() => {
            copyStatus.hidden = true;
          }, 2200);
        }
      });
    }

    if (useDiscountLink) {
      useDiscountLink.addEventListener('click', markClaimed);
    }

    const scheduleOpen = () => {
      window.setTimeout(open, delaySeconds * 1000);
    };

    if (isAgeVerified()) {
      scheduleOpen();
    } else {
      const ageConfirm = document.querySelector('[data-age-gate-confirm]');
      if (ageConfirm) {
        ageConfirm.addEventListener('click', scheduleOpen, { once: true });
      }
      document.addEventListener('lollipop:age-verified', scheduleOpen, { once: true });
    }

    document.addEventListener('mouseout', (event) => {
      if (!desktopQuery.matches || event.clientY > 12 || !canOpen()) return;
      open();
    });
  };

  const bindScrollAnimations = () => {
    const animatedSelectors = ['.faq-item', '.trust-item'];
    const elements = document.querySelectorAll(animatedSelectors.join(','));

    for (const el of elements) {
      el.classList.add('fade-in-section');
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    for (const el of elements) {
      observer.observe(el);
    }
  };

  const bindHeroCarousel = () => {
    const buildRandomSlides = (root) => {
      const poolNode = root.querySelector('[data-hero-pool]');
      const first = root.querySelector('[data-hero-slide]');
      const dots = root.querySelectorAll('[data-hero-dot]');
      if (!poolNode || !first || dots.length < 2) return;
      let pool = [];
      try { pool = JSON.parse(poolNode.textContent); } catch (error) { return; }
      const shown = new Set([...first.querySelectorAll('[data-hero-handle]')].map((a) => a.dataset.heroHandle));
      const rest = pool.filter((item) => !shown.has(item.handle));
      for (let i = rest.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [rest[i], rest[j]] = [rest[j], rest[i]];
      }
      let anchor = first;
      for (let s = 1; s < dots.length && rest.length >= 3; s += 1) {
        const slide = document.createElement('div');
        slide.className = 'hero-aplus__slide';
        slide.dataset.heroSlide = '';
        slide.setAttribute('aria-hidden', 'true');
        slide.inert = true;
        rest.splice(0, 3).forEach((item, i) => {
          const link = document.createElement('a');
          link.href = item.url;
          link.className = `hero-aplus__item hero-aplus__item--${i + 1}`;
          link.setAttribute('aria-label', item.title);
          const img = document.createElement('img');
          img.className = 'hero-aplus__img';
          img.src = item.src;
          img.srcset = item.srcset;
          img.sizes = '(max-width: 749px) 30vw, 15vw';
          img.alt = item.title;
          img.loading = 'lazy';
          img.decoding = 'async';
          link.appendChild(img);
          slide.appendChild(link);
        });
        anchor.after(slide);
        anchor = slide;
      }
      const built = root.querySelectorAll('[data-hero-slide]').length;
      dots.forEach((dot, i) => { if (i >= built) dot.remove(); });
      if (built < 2) root.querySelector('.hero-aplus__controls')?.remove();
    };

    document.querySelectorAll('[data-hero-carousel]').forEach((root) => {
      buildRandomSlides(root);
      const slides = [...root.querySelectorAll('[data-hero-slide]')];
      if (slides.length < 2) return;
      const dots = [...root.querySelectorAll('[data-hero-dot]')];
      const toggle = root.querySelector('[data-hero-toggle]');
      const delay = Math.max(4, Number(root.dataset.interval) || 6) * 1000;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;
      let timer = null;
      let paused = reduced;
      let hovering = false;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
          if (i === current) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      };
      const stop = () => { window.clearInterval(timer); timer = null; };
      const start = () => {
        stop();
        if (paused || hovering || document.hidden) return;
        timer = window.setInterval(() => show(current + 1), delay);
      };
      const setPaused = (value) => {
        paused = value;
        if (toggle) {
          toggle.setAttribute('aria-pressed', String(value));
          toggle.setAttribute('aria-label', value ? 'Reanudar carrusel' : 'Pausar carrusel');
        }
        start();
      };

      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
      toggle?.addEventListener('click', () => setPaused(!paused));
      root.addEventListener('mouseenter', () => { hovering = true; stop(); });
      root.addEventListener('mouseleave', () => { hovering = false; start(); });
      root.addEventListener('focusin', () => { hovering = true; stop(); });
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) { hovering = false; start(); } });
      document.addEventListener('visibilitychange', start);

      let touchX = null;
      root.addEventListener('touchstart', (event) => { touchX = event.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', (event) => {
        if (touchX === null) return;
        const dx = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 40) { show(current + (dx < 0 ? 1 : -1)); start(); }
      }, { passive: true });

      setPaused(paused);
    });
  };

  // PDP con variantes: al elegir otra variante se actualizan el precio visible, el de la barra fija
  // y la previsión «Con este producto en tu carrito».
  const bindVariantPrice = () => {
    const form = document.querySelector('.pdp__form');
    if (!form) return;
    form.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'id' || !input.dataset.price) return;
      // Show the chosen variant's own photo (color, flavour) in the gallery.
      if (input.dataset.mediaId) {
        document.dispatchEvent(new CustomEvent('pdp:show-media', { detail: { mediaId: input.dataset.mediaId } }));
      }
      const cents = Number(input.dataset.price);
      const text = formatMoney(cents / 100, 'COP');
      document.querySelectorAll('.pdp__price-row .price__current, [data-pdp-sticky-price]').forEach((node) => { node.textContent = text; });
      const forecast = document.querySelector('.pdp__threshold [data-order-threshold]');
      if (forecast) {
        forecast.dataset.add = String(cents);
        void refreshCart().then((cart) => window.LollipopThreshold?.render?.(cart)).catch(() => {});
      }
    });
  };

  const initStickyATC = () => {
    const stickyBar = document.querySelector('[data-desktop-sticky-bar]');
    const productSubmit = document.querySelector('.product-form__submit');
    if (!stickyBar || !productSubmit) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { rootMargin: '0px', threshold: 0 }
    );
    observer.observe(productSubmit);

    const stickyButton = stickyBar.querySelector('[data-desktop-sticky-add]');
    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        productSubmit.click();
      });
    }
  };

  const bindRecentlyViewed = () => {
    const STORAGE_KEY = 'lollipop_recently_viewed';
    const MAX_STORED = 8;
    const MAX_SHOWN = 4;

    const escapeHtml = (value) =>
      String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char]);

    const readStored = () => {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    };

    const writeStored = (items) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch {
        // Private browsing or storage disabled: recently viewed just won't persist.
      }
    };

    let stored = readStored();
    let currentId = null;

    const currentProductScript = document.querySelector('[data-current-product]');
    if (currentProductScript) {
      try {
        const current = JSON.parse(currentProductScript.textContent);
        if (current && current.id) {
          currentId = current.id;
          stored = [current, ...stored.filter((item) => item.id !== current.id)].slice(0, MAX_STORED);
          writeStored(stored);
        }
      } catch {
        // Malformed current-product payload: skip recording this view.
      }
    }

    const slot = document.querySelector('[data-recently-viewed]');
    const grid = document.querySelector('[data-recently-viewed-grid]');
    if (!slot || !grid) return;

    const toShow = stored.filter((item) => item.id !== currentId).slice(0, MAX_SHOWN);
    if (!toShow.length) return;

    // Datos frescos (precio, disponibilidad, variantes) desde /products/<handle>.js; la tarjeta es la misma de snippets/product-card.
    const handleOf = (url) => (String(url || '').match(/\/products\/([^/?#]+)/) || [])[1];
    const loadFresh = async (item) => {
      const handle = handleOf(item.url);
      if (!handle) return null;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`, { headers: { Accept: 'application/json' } });
        return response.ok ? response.json() : null;
      } catch {
        return null;
      }
    };
    const cardAction = (product) => {
      const url = escapeHtml(product.url);
      if (!product.available) return `<a href="${url}" class="button button--secondary button--small product-card__add">Ver detalle</a>`;
      const variants = product.variants || [];
      if (variants.length === 1) {
        return `<form method="post" action="/cart/add" class="quick-add" data-quick-add>
            <input type="hidden" name="id" value="${variants[0].id}">
            <button type="submit" class="button button--secondary button--small product-card__add" data-quick-add-btn>+ Agregar</button>
          </form>`;
      }
      return `<a href="${url}" class="button button--secondary button--small product-card__add">Elegir opción</a>`;
    };
    const renderCard = (product) => {
      const url = escapeHtml(product.url);
      const image = product.featured_image ? `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=400` : '';
      return `
        <article class="product-card" data-product-id="${product.id}">
          <a href="${url}" class="product-card__media" tabindex="-1" aria-hidden="true">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" class="product-card__image" loading="lazy" width="400" height="400">` : '<span class="product-card__placeholder"></span>'}
            ${product.available ? '' : '<span class="product-card__badge">Agotado</span>'}
          </a>
          <div class="product-card__content">
            <a href="${url}" class="product-card__title">${escapeHtml(product.title)}</a>
            <div class="product-card__meta">
              <div class="price"><span class="price__current">${formatMoney(Number(product.price) / 100, 'COP')}</span></div>
              ${product.available ? '<span class="product-card__stock">Disponible</span>' : ''}
            </div>
            ${cardAction(product)}
          </div>
        </article>`;
    };

    void Promise.all(toShow.map(loadFresh)).then((products) => {
      const fresh = products.filter(Boolean);
      if (!fresh.length) return;
      grid.innerHTML = fresh.map(renderCard).join('');
      slot.hidden = false;
    });
  };

  // «Más vendidos»: orden best-selling real de Shopify. Los productos sin ventas quedan
  // empatados y Shopify los ordena por fecha de creación; aquí se corta donde empieza ese empate.
  const initBestSellers = async () => {
    const root = document.querySelector('[data-best-sellers]');
    const grid = root?.querySelector('[data-best-sellers-grid]');
    if (!root || !grid) return;
    const limit = Number(root.getAttribute('data-limit') || 8);
    const base = `${window.Shopify?.routes?.root || '/'}collections/all`;
    const load = async (sort) => {
      try {
        const response = await fetch(`${base}?sort_by=${sort}&section_id=best-sellers-feed`);
        if (!response.ok) return [];
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        return [...doc.querySelectorAll('[data-feed-item]')].map((el) => ({
          id: el.getAttribute('data-feed-item'),
          available: el.getAttribute('data-available') === 'true',
          html: el.innerHTML,
        }));
      } catch {
        return [];
      }
    };
    const [best, newest] = await Promise.all([load('best-selling'), load('created-descending')]);
    let withSales = best.length;
    for (let i = 0; i < best.length; i += 1) {
      const window_ = Math.min(5, best.length - i);
      if (window_ < 3) break;
      const top = new Set(best.slice(0, i).map((item) => item.id));
      const rest = newest.filter((item) => !top.has(item.id));
      if (best.slice(i, i + window_).every((item, j) => rest[j]?.id === item.id)) {
        withSales = i;
        break;
      }
    }
    const picks = best.slice(0, withSales).filter((item) => item.available).slice(0, limit);
    if (picks.length < 2) return;
    grid.innerHTML = picks.map((item) => item.html).join('');
    root.hidden = false;
  };

  // PDP A+: galería deslizable con contador y miniaturas, y selector de cantidad.
  const bindPdpGallery = () => {
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    const counter = document.querySelector('[data-pdp-counter]');
    const thumbs = [...document.querySelectorAll('[data-pdp-thumb]')];
    const slides = [...gallery.children];
    const setActive = (index) => {
      if (counter) counter.textContent = String(index + 1);
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    };
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        gallery.scrollTo({ left: slides[i].offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
    document.addEventListener('pdp:show-media', (event) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(event.detail?.mediaId));
      if (index < 0) return;
      // Far slides are lazy; start the download before scrolling to it.
      const image = slides[index].querySelector('img');
      if (image) image.loading = 'eager';
      gallery.scrollTo({ left: slides[index].offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      setActive(index);
    });
    // A shared link to one variant (?variant=) opens on that variant's photo.
    const checked = document.querySelector('.pdp__form input[name="id"]:checked');
    if (checked instanceof HTMLInputElement && checked.dataset.mediaId && new URL(window.location.href).searchParams.has('variant')) {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === checked.dataset.mediaId);
      if (index > 0) {
        gallery.scrollTo({ left: slides[index].offsetLeft - gallery.offsetLeft });
        setActive(index);
      }
    }
    let ticking = false;
    gallery.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        const index = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        setActive(Math.min(slides.length - 1, Math.max(0, index)));
      });
    }, { passive: true });
  };

  const bindQuantitySteppers = () => {
    document.querySelectorAll('[data-qty]').forEach((root) => {
      const input = root.querySelector('input');
      if (!(input instanceof HTMLInputElement)) return;
      root.querySelectorAll('[data-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = Math.max(1, (Number(input.value) || 1) + Number(button.getAttribute('data-qty-step')));
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  };

  const bindCollectionSeoToggle = () => {
    const blocks = document.querySelectorAll('[data-collection-seo]');
    for (const block of blocks) {
      const content = block.querySelector('[data-collection-seo-content]');
      const toggle = block.querySelector('[data-collection-seo-toggle]');
      if (!content || !toggle) continue;

      window.requestAnimationFrame(() => {
        const hasOverflow = content.scrollHeight > content.clientHeight + 8;
        block.classList.toggle('has-overflow', hasOverflow);
        if (!hasOverflow) {
          toggle.hidden = true;
        }
      });

      toggle.addEventListener('click', () => {
        const expanded = block.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Mostrar menos' : 'Leer más';
      });
    }
  };

  const initSearchNameMatches = async () => {
    const root = document.querySelector('.main-search[data-search-query]');
    const query = root?.dataset.searchQuery.trim();
    if (!query || query.length < 2) return;
    const params = new URL(window.location.href).searchParams;
    // Respect explicit filters, price sorting and subsequent result pages.
    if (Number(params.get('page') || 1) > 1 ||
        [...params.keys()].some(key => key.startsWith('filter.')) ||
        (params.has('sort_by') && params.get('sort_by') !== 'relevance')) return;
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('es').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    // Tolerate simple Spanish plural/gender endings (liquidas/liquida,
    // concentrados/concentrada) so a near-exact title still counts as a
    // name match. Longer suffixes are checked first so "liquidas" and
    // "liquida" both reduce to "liquid" instead of stopping at "liquida".
    const stem = word => word.replace(/(as|os|es|a|o|e|s)$/, '');
    const wordMatches = (queryWord, titleWords) => titleWords.some(titleWord =>
      titleWord === queryWord || stem(titleWord) === stem(queryWord));
    const normalizedQuery = normalize(query);
    if (!normalizedQuery) return;
    const words = normalizedQuery.split(/\s+/);
    const endpoint = new URL(root.dataset.predictiveUrl, window.location.origin);
    endpoint.search = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': '5',
      'resources[options][unavailable_products]': params.get('options[unavailable_products]') || 'last',
      section_id: 'search-name-matches',
    }).toString();
    // The section-rendering endpoint occasionally misses on the very first
    // request right after navigation; one quick retry avoids requiring the
    // shopper to reload the page for the match to show up.
    const fetchWithRetry = async (attempt = 0) => {
      try {
        const response = await fetch(endpoint.href, { cache: 'no-store' });
        if (!response.ok) throw new Error(`status ${response.status}`);
        return await response.text();
      } catch (error) {
        if (attempt >= 2) throw error;
        await new Promise(resolve => window.setTimeout(resolve, 300 * (attempt + 1)));
        return fetchWithRetry(attempt + 1);
      }
    };
    try {
      const html = await fetchWithRetry();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const matches = [...doc.querySelectorAll('[data-search-match]')]
        .filter(node => {
          const titleWords = normalize(node.dataset.productTitle).split(/\s+/);
          return words.every(word => wordMatches(word, titleWords));
        })
        .sort((a, b) => Number(normalize(b.dataset.productTitle) === normalizedQuery) -
          Number(normalize(a.dataset.productTitle) === normalizedQuery));
      if (!matches.length) return;
      const grid = root.querySelector('[data-search-name-grid]');
      const nativeGrid = root.querySelector('[data-search-native-grid]');
      const ids = new Set();
      for (const match of matches) {
        if (ids.has(match.dataset.productId)) continue;
        const card = match.querySelector('.product-card');
        if (!card) continue;
        ids.add(match.dataset.productId);
        grid.append(card);
      }
      if (!ids.size) return;
      nativeGrid.querySelectorAll('.product-card').forEach(card => {
        if (ids.has(card.dataset.productId)) card.remove();
      });
      root.querySelectorAll('.empty-state, .search-discovery').forEach(node => { node.hidden = true; });
      const count = root.querySelector('.search-results__count');
      if (count) {
        count.textContent = 'Más resultados del catálogo';
        count.hidden = !nativeGrid.querySelector('.product-card, .pagination');
      }
      root.querySelector('[data-search-name-matches]').hidden = false;
    } catch (error) {
      // Native Liquid results remain usable if predictive search is unavailable.
      console.warn('[Lollipop] name matches unavailable', error);
    }
  };

  // Normalize old bookmarks and external search links to the same explicit
  // availability policy as predictive search. Preserve filters and pagination.
  const normalizeSearchOptions = () => {
    if (!document.querySelector('.main-search')) return;
    const url = new URL(window.location.href);
    if (!url.searchParams.get('q')?.trim()) return;
    if (url.searchParams.has('options[unavailable_products]')) return;
    url.searchParams.set('options[unavailable_products]', 'last');
    window.location.replace(url.href);
  };

  const bootstrap = async () => {
    normalizeSearchOptions();
    void initSearchNameMatches();
    bindMobileMenu();
    bindCartDrawer();
    bindStandaloneCartAdds();
    void initPdpCrossSell();
    bindPdpGallery();
    void initBestSellers();
    bindQuantitySteppers();
    bindSearchToggle();
    bindMegaMenu();
    bindAgeVerification();
    bindProductForm();
    bindQuickAdd();
    bindCollectionSeoToggle();
    bindRecentlyViewed();
    bindLeadDiscountCapture();
    initStickyATC();
    bindVariantPrice();
    bindHeroCarousel();
    bindScrollAnimations();
    await refreshCart().catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      void bootstrap();
    }, { once: true });
  } else {
    void bootstrap();
  }
})();
